__turbopack_context__.v({
  "cell_text": "TableDesktopCell-module-scss-module__Mz5ewG__cell_text",
  "header_image_cell": "TableDesktopCell-module-scss-module__Mz5ewG__header_image_cell",
  "header_text": "TableDesktopCell-module-scss-module__Mz5ewG__header_text",
  "helper_text": "TableDesktopCell-module-scss-module__Mz5ewG__helper_text",
  "helper_text_placeholder": "TableDesktopCell-module-scss-module__Mz5ewG__helper_text_placeholder",
  "image_cell": "TableDesktopCell-module-scss-module__Mz5ewG__image_cell",
  "table_cell": "TableDesktopCell-module-scss-module__Mz5ewG__table_cell",
});
